export const environment = {
    production: false,
    local: false,
    hmr: false,
    debugEnabled: true,
    ICE_SERVERS: [
        { urls: ['turn:51.178.80.88:3478'], credential: 'Idra2017', username: 'idra' },
        { urls: 'stun:stun.l.google.com:19302' }
    ],
    webSocketUrl: 'wss://exellente.it/exellente/exellentews',
    api_base_url: 'https://app-exellente.maregroup.it/api/bo',
};
